import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface ConsultationContextType {
  isOpen: boolean;
  openModal: (redirectPath?: string) => void;
  closeModal: () => void;
  onFormSubmit: () => void;
}

const ConsultationContext = createContext<ConsultationContextType | undefined>(undefined);

export const ConsultationProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  
  // Track auto-popup stages:
  // 0 = Initial Load
  // 1 = First Popup Shown
  // 2 = Closed Once (Waiting for second trigger)
  // 3 = Second Popup Shown (Done)
  const [popupStage, setPopupStage] = useState(0);
  
  const navigate = useNavigate();

  // --- AUTO POP-UP LOGIC ---
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (popupStage === 0) {
      // 1. Website Open hone ke 12 Seconds baad
      timer = setTimeout(() => {
        setIsOpen(true);
        setPopupStage(1); 
      }, 1000); 
    } 
    else if (popupStage === 2) {
      // 2. Hatane (Close karne) ke 5 Seconds baad fir se
      timer = setTimeout(() => {
        setIsOpen(true);
        setPopupStage(3); // Stage 3 means final, iske baad auto nahi aayega
      }, 3000); 
    }

    return () => clearTimeout(timer);
  }, [popupStage]);

  // --- MODAL CONTROLS ---
  const openModal = (path?: string) => {
    if (path) setRedirectPath(path);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    
    // Agar pehli baar dikha tha (Stage 1) aur close kiya, 
    // to Stage 2 set karo taaki agla 5 sec wala timer chalu ho jaye
    if (popupStage === 1) {
      setPopupStage(2);
    }
  };

  const onFormSubmit = () => {
    setIsOpen(false);
    // Submit hone par hum 'Stage 3' (Done) set kar dete hain 
    // taaki user ko pareshan na karein
    setPopupStage(3); 

    if (redirectPath) {
      navigate(redirectPath);
      setRedirectPath(null);
    }
  };

  return (
    <ConsultationContext.Provider value={{ isOpen, openModal, closeModal, onFormSubmit }}>
      {children}
    </ConsultationContext.Provider>
  );
};

export const useConsultation = () => {
  const context = useContext(ConsultationContext);
  if (!context) throw new Error('useConsultation must be used within a ConsultationProvider');
  return context;
};